import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import Body from "@/ui/Body";
import Facebook from "@/assets/Facebook2.svg";
import LinkedIn from "@/assets/LinkedIn.svg";
import Email from "@/assets/Email.svg";
import FormSection from "../FormSection";
import { getGlobal } from "@/functions/getGlobal";


export default function Blog({ blog = {}, consultant = {}, filtered_blogs = [], className = "" }) {

  const [basePath, setBasePath] = useState('');
  const global = getGlobal();
  const email = global["_theme.company.email"];

  useEffect(() => {
    const baseUrl = window.location.protocol + "//" + window.location.host;
    setBasePath(baseUrl);
  }, []);

  const router = useRouter();
  const pathName = basePath + router.asPath;

  return (
    <>
      <div className={clsx(className, classes.blog)}>
        <div className={classes.blog_content}>
          <div className={classes.description}>
            <Body body={blog?.body} />
          </div>
          <FormSection title="Share your thoughts" formId="d11e166a-abb9-44bd-91dc-915a1ebf0d34" redirect_url="/thank-you" />
        </div>

        <div className={classes.additional_col}>
          {
            consultant.name &&
            <>
              <h5 className={classes.title}>Author</h5>

              <div className={classes.consultant}>
                <div className={classes.profile}>
                  <img className={classes.profile_image} src={consultant.profile_image ?? '/profile_placeholder.jpg'} alt={consultant.name} />
                  <div className={classes.details}>
                    <Link href={"/consultants/" + consultant.url_slug} passHref>
                      <h5 className={classes.name}>{consultant.name}</h5>
                    </Link>
                    <div className={classes.description}>{consultant.position_title}</div>
                  </div>
                  <div className={classes.contact}>
                  </div>
                </div>
              </div>
            </>
          }


          <div className={classes.sharing}>
            <h5 className={classes.title}>Share this Insight</h5>
            <div className={classes.socials}>
              <a className={classes.social_icon} href={"https://www.linkedin.com/sharing/share-offsite/?url=" + pathName} target="_blank" rel="nofollow">
                <LinkedIn width={19} height={19} />
              </a>
              <a className={classes.social_icon} href={"https://www.facebook.com/sharer/sharer.php?u=" + pathName} target="_blank" rel="nofollow">
                <Facebook width={19} height={19} />
              </a>
              <a className={classes.social_icon} href={`mailto: ${email}?body=${encodeURIComponent(pathName)}`} target="_blank" rel="nofollow">
                <Email width={19} height={19} />
              </a>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}